module.exports = __webpack_public_path__ + "img/QM.47977802.png";